export const initialState = {
  request: null,
  loading: false,
  balance: {},
  error: null,
  nextTokens: { 1: null },
  pointTransactions: [],
  pointTransactionsLoading: false,
  pointTransactionsError: null,
  products: [],
  productLoading: false,
  productError: null,
  product: {},
  productDetailLoading: false,
  productDetailError: null,
  productNextTokens: { 1: null },
  redemptionLoading: false,
  redemptionError: null,
  redemption: {},
  redemptionDetail: {},
  redemptionDetailLoading: false,
  redemptionDetailError: null,
  redemptions: [],
  redemptionsLoading: false,
  redemptionsError: null,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "REQUEST_GET_POINT_BALANCE":
      return {
        ...state,
        request: action.payload.request,
        loading: true,
        balance: initialState.balance,
        error: null,
      };
    case "REQUEST_GET_POINT_BALANCE_SUCCESS":
      return {
        ...state,
        request: null,
        loading: false,
        balance: action.payload.balance,
      };
    case "REQUEST_GET_POINT_BALANCE_ERROR":
      return {
        ...state,
        request: null,
        loading: false,
        error: action.payload.error,
      };
    case "CLEAR_BALANCE":
      return {
        ...state,
        request: null,
        loading: false,
        balance: initialState.balance,
        error: null,
      };
    case "REQUEST_LIST_POINT_TRANSACTION":
      return {
        ...state,
        pointTransactionsLoading: true,
        nextTokens:
          action.payload.page === 1
            ? initialState.nextTokens
            : state.nextTokens,
        pointTransactionsError: null,
      };
    case "SUCCESS_LIST_POINT_TRANSACTION":
      return {
        ...state,
        pointTransactionsLoading: false,
        pointTransactions: action.payload.items,
        nextTokens: {
          ...state.nextTokens,
          [action.payload.nextPage]: action.payload.nextToken,
        },
      };
    case "ERROR_LIST_POINT_TRANSACTION":
      return {
        ...state,
        pointTransactionsLoading: false,
        pointTransactionsError: action.error,
      };
    case "REQUEST_LIST_REWARDS_PRODUCT":
      return {
        ...state,
        request: action.payload.request,
        products: [],
        productNextTokens:
          action.payload.page === 1
            ? initialState.productNextTokens
            : state.productNextTokens,
        productLoading: true,
        productError: null,
      };
    case "LIST_REWARDS_PRODUCT_SUCCESS":
      return {
        ...state,
        request: null,
        products: action.payload.products,
        productNextTokens: {
          ...state.productNextTokens,
          [action.payload.nextPage]: action.payload.nextToken,
        },
        productLoading: false,
      };
    case "LIST_REWARDS_PRODUCT_ERROR":
      return {
        ...state,
        request: null,
        productLoading: false,
        productError: action.error,
      };
    case "REQUEST_GET_REWARDS_PRODUCT":
      return {
        ...state,
        request: action.payload.request,
        product: {},
        productDetailLoading: true,
        productDetailError: null,
      };
    case "GET_REWARDS_PRODUCT_SUCCESS":
      return {
        ...state,
        request: null,
        product: action.payload.product,
        productDetailLoading: false,
      };
    case "GET_REWARDS_PRODUCT_ERROR":
      return {
        ...state,
        request: null,
        productDetailLoading: false,
        productDetailError: action.error,
      };
    case "REQUEST_REDEEM_POINT":
      return {
        ...state,
        request: action.payload.request,
        redemptionLoading: true,
        redemptionError: null,
        redemption: null,
      };
    case "REDEEM_POINT_SUCCESS":
      return {
        ...state,
        request: null,
        redemptionLoading: false,
        redemption: action.payload.redemption,
      };
    case "REDEEM_POINT_ERROR":
      return {
        ...state,
        request: null,
        redemptionLoading: false,
        redemptionError: action.error,
      };
    case "REQUEST_GET_REWARDS_REDEMPTION":
      return {
        ...state,
        request: action.payload.request,
        redemptionDetailLoading: true,
        redemptionDetailError: null,
      };

    case "GET_REWARDS_REDEMPTION_SUCCESS":
      return {
        ...state,
        request: null,
        redemptionDetailLoading: false,
        redemptionDetail: action.payload.redemption,
      };

    case "GET_REWARDS_REDEMPTION_ERROR":
      return {
        ...state,
        request: null,
        redemptionDetailLoading: false,
        redemptionDetailError: action.error,
      };
    case "REQUEST_LIST_REWARDS_REDEMPTION":
      return {
        ...state,
        redemptions: [],
        nextTokens:
          action.payload.page === 1
            ? initialState.nextTokens
            : state.nextTokens,
        redemptionsLoading: true,
        redemptionsError: null,
      };

    case "LIST_REWARDS_REDEMPTION_SUCCESS":
      return {
        ...state,
        redemptionsLoading: false,
        redemptions: action.payload.items,
        nextTokens: {
          ...state.nextTokens,
          [action.payload.nextPage]: action.payload.nextToken,
        },
      };

    case "LIST_REWARDS_REDEMPTION_ERROR":
      return {
        ...state,
        redemptionsLoading: false,
        redemptionsError: action.error,
      };
    case "CLEAR_REDEEM_POINT":
      return {
        ...state,
        redemption: {},
        redemptionError: null,
      };
    default:
      return state;
  }
};
